/* eslint-disable angular/factory-name */
angular.
module("digiexam.services").
factory("course", function course($http) {
	"use strict";
	return {
		get: function get(id) {
			return $http.get("/course/" + id).then(function handleResponse(response) {
				return response.data;
			});
		},
		getAll: function getAll() {
			return $http.get("/course/list/").then(function handleResponse(response) {
				return response.data;
			});
		},
		create: function create(title) {
			return $http.post("/course/create/", {title: title}).
			then(function handleResponse(response) {
				return response.data;
			});
		},
		addGroup: function addGroup(courseId, classId) {
			return $http.post("/course/addgroup/", {
				courseId: parseInt(courseId, 10),
				groupId: parseInt(classId, 10),
			}).
			then(function handleResponse(response) {
				return response.data;
			});
		},
		update: function update(c) {
			return $http.post("/course/update/", {course: c}).
			then(function handleResponse(response) {
				return response.data;
			});
		},
	};
});
